module.exports = __webpack_public_path__ + "img/unreal-logo.b87fb365.png";